import { Title } from "../../common/styles";
import { prices, pricesKit } from "./prices";
import { StyledSection, PricesList, ListElement, Dots, Price, KitBlock, Kit } from "./styled";

const PricePage = () => {
    return (
        <StyledSection>
            <Title>Для жінок</Title>
            <PricesList>
                {prices.map((e) => (
                    <ListElement key={e.name}>
                        {e.name}
                        <Dots />
                        <Price>{e.price}</Price>
                    </ListElement>
                ))}
            </PricesList>
            <Title>Комплекси</Title>
            <PricesList>
                {pricesKit.map((e, i) => (
                    <ListElement key={i}>
                        <KitBlock>{e.name.map((e) => <Kit key={e}>{e}</Kit>)}</KitBlock>
                        {e.price &&
                            <>
                                <Dots />
                                <Price>{e.price}</Price>
                            </>
                        }
                    </ListElement>
                ))}
            </PricesList>
        </StyledSection>
    )
};

export default PricePage;